import MuiLink, { LinkProps as MuiLinkProps } from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import React, { FunctionComponent } from "react";
import { AFTER, FOCUS_VISIBLE } from "designSystem/theme";

const PREFIX = "Link";

const classes = {
	full: `${PREFIX}full`,
	grow: `${PREFIX}grow`,
};

const StyledMuiLink = styled(MuiLink)(({
	theme,
}) => ({
	[`&.${classes.full}`]: {
		...COMMON,
		width: "100%",
	},

	[`&.${classes.grow}`]: {
		...COMMON,
		flexGrow: 1,
	},
}));

/**
 * The Link component adds focus without imposing a margin or padding, allowing the
 * consumer to specify margin and padding as desired. When a Link needs to grow and
 * have no overflow (hidden), the default focus styling will not work. Use this component instead.
 */

const COMMON = {
	padding: 4,
	margin: -4,
	overflow: "hidden",

	[FOCUS_VISIBLE]: {
		[AFTER]: {
			top: 2,
			left: 2,
			width: "calc(100% - 4px)",
			height: "calc(100% - 4px)",
		},
	},
};

export interface LinkProps extends Omit<MuiLinkProps, "color"> {
	/** indicates link should grow to full width of non-flex container */
	fullWidth?: boolean;

	/** indicates link should grow to full width of flex container */
	grow?: boolean;
}

export const Link: FunctionComponent<LinkProps> = (props) => {
	const { className, fullWidth, grow, ...otherProps } = props;

	return (
		<StyledMuiLink
			className={`${fullWidth ? classes.full : ""} ${grow ? classes.grow : ""} ${className || ""}`}
			{...otherProps}
		/>
	);
};

export default Link;